import { render, staticRenderFns } from "./idempiereSynchro.vue?vue&type=template&id=45efb67e&"
import script from "./idempiereSynchro.vue?vue&type=script&lang=js&"
export * from "./idempiereSynchro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports